const Img1 = '/assets/images/contact/animation/1.png';
const Img2 = '/assets/images/contact/animation/2.png';
const Img4 = '/assets/images/contact/animation/4.png';
const Img5 = '/assets/images/contact/animation/5.png';

const ContactBackgroundImages = [
    {
        img: Img1
    },
    {
        img: Img2
    },
    {
        img: Img4
    },
    {
        img: Img5
    }
]

export default ContactBackgroundImages
